// @flow

import React, { type Node } from 'react';

import {
  useIncomingPayment,
  getMerchant,
  getRedirectUrlAfterPayment,
  getCountry,
} from '@tectonics/prs/incoming-payment';

import { getName as getMerchantName } from '@tectonics/prs/merchant';
import { Box, Center, Padding, Link, Text, Hr } from '../../../atoms';

export function MerchantInfo(): Node {
  const incomingPayment = useIncomingPayment();
  const country = getCountry(incomingPayment);

  switch (country) {
    case 'mx':
      return <LatamMerchantInfo />;

    default:
      throw new Error(`Merchant info: country ${country} is not supported`);
  }
}

function LatamMerchantInfo(): Node {
  const incomingPayment = useIncomingPayment();
  const merchant = getMerchant(incomingPayment);
  const merchantName = getMerchantName(merchant);
  const redirectUrl = getRedirectUrlAfterPayment(incomingPayment);

  return (
    <Padding to="ml">
      <Box flavor="info">
        <Padding>
          <Center>
            <Text center flavor="info">
              Si lo desea, puede volver a
              {'\u00A0'}
              <strong>{merchantName}</strong>
              {'\u00A0'}
              haciendo clic en el siguiente botón:
            </Text>
            <Hr />
            <Link as="a" type="primary" flat outline rounded href={redirectUrl}>
              Volver a {merchantName}
            </Link>
          </Center>
        </Padding>
      </Box>
    </Padding>
  );
}
